import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { getlang, setlang } from 'src/helper/getlang'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import langM from './lang'
import score from 'src/helper/score'
import {
  apiGetHistoryRank,
  apiUserGetHistoryRank,
  apiUserGetHistoryRankStat,
  apiGetLastWeek,
  apiGetWeekGift,
  apiGetWeekGiftRank,
  apiGetRoomGiftRank,
  apiGetCountDown,
} from 'src/store/activity/week'
import cdn from 'src/helper/cdn'
import { jumpToUser, jumpToRoom, shareToLink, shareToWhatsapp } from 'src/helper/webviewFun'
import { history } from 'src/core/router'
@inject('store')
@observer
export default class WeekStar extends React.Component {
  constructor(props) {
    super(props)
  }
  state = {
    UserHistoryRankListStatus: false,
    rank1Num: 0,
    rank2Num: 0,
    rank3Num: 0,
    share: false,
    historyRank: [],
    historyRankList: [],
    historyRankListLen: 0,
    userhistoryRank: [],
    userhistoryRankList: [],
    userhistoryRankListLen: 0,
    champion: '',
    gift: [],
    giftrank: [],
    giftrank1: [],
    giftrank2: [],
    giftrank3: [],
    giftrank4: [],
    myrank1: {},
    myrank2: {},
    myrank3: {},
    myrank4: {},
    groupRank: [],
    myGroupRank: {},
    giftNum: 0,
    number: 0,
    countdown: 0,
    time: 0,
    uid: '',
    tab: 0,
    lang: langM.en,
    language: 'en',
    rewardList: [
      {
        list: [
          {
            days: 'Star car 7D',
            days_tr: `Araç (7 Gün)`,
            days_ar: 'سيارة النجم ( 7 أيام ) ',
            pic: '/img/activity/weekly/reward/a1.png',
          },
          {
            days: 'Golden badge 7D<br/>(score>400K)',
            days_tr: `Madalya (7 Gün)`,
            days_ar: 'الشارة الذهبية 7 أيام ( دائمة : الفوز 3 مرات ) ',
            pic: '/img/activity/weekly/reward/a2.png',
          },
          {
            days: 'Special gift 7D',
            days_tr: `Özel Hediye (7 Gün)`,
            days_ar: 'هدية خاصة ( 7 أيام ) ',
            pic: '/img/activity/weekly/reward/a3.png',
          },
          {
            days: 'Golden headwear 7D',
            days_tr: `Çerçeve (7 Gün)`,
            days_ar: 'إطار 7 أيام ',
            pic: '/img/activity/weekly/reward/a4.png',
          },
          {
            days: '7 days',
            days_tr: `Vip 4 (7 Gün)`,
            days_ar: '7 days',
            pic: 'https://img.chatie.live/app/noble/duke.png',
          },
        ],
      },
      {
        list: [
          {
            days: 'Car 7D',
            days_tr: `Araç (7 Gün)`,
            days_ar: 'سيارة 7 أيام ',
            pic: '/img/app/week/motorboat.png',
          },
          {
            days: 'Silver badge 7D<br/>(score>300K)',
            days_tr: `Madalya (7 Gün)`,
            days_ar: 'الشارة الفضية 7 أيام ( دائمة : الفوز 3 مرات ) ',
            pic: '/img/activity/weekly/reward/b2.png',
          },
          {
            days: 'Headwear 7D',
            days_tr: `Çerçeve (7 Gün)`,
            days_ar: 'إطار 7 أيام ',
            pic: '/img/activity/weekly/reward/b3.png',
          },
          {
            days: '7 days',
            days_tr: `Vip3 (7Gün)`,
            days_ar: '7 days',
            pic: 'https://img.chatie.live/app/noble/marquis.png',
          },
        ],
      },
      {
        list: [
          {
            days: 'Car 7D',
            days_tr: `Araç (7 Gün)`,
            days_ar: 'سيارة 7 أيام ',
            pic: '/img/app/week/motorboat.png',
          },
          {
            days: 'Copper badge 7D<br/>(score>200K)',
            days_tr: `Madalya (7 Gün)`,
            days_ar: 'الشارة النحاسية 7 أيام ( دائمة : الفوز 3 مرات ) ',
            pic: '/img/activity/weekly/reward/c2.png',
          },
          {
            days: 'Headwear 7D',
            days_tr: `Çerçeve (7 Gün)`,
            days_ar: 'إطار 7 أيام ',
            pic: '/img/activity/weekly/reward/b3.png',
          },
          {
            days: '7 days',
            days_tr: `VIP 2 (7 Gün)`,
            days_ar: '7 days',
            pic: 'https://img.chatie.live/app/noble/count.png',
          },
        ],
      },
    ],
    rrShow: false,
  }

  async componentWillMount() {
    setDocumentTitle('WeeklyStar')
    // ()
    /* let nimsr = parseInt(new Date().getTime() /1000)
    if (nimsr>=1718553900) {
      history.replace(`/activity/newWeeklyStar`)
    } */
    let { language } = this.props.location.query
    language = await getlang(language)
    console.log('language', language)
    this.setState({
      lang: setlang(language, langM),
      language: language,
    })
    let uid = await setUidToken(this.props.location.query)

    try {
      let connectionInfo = window.navigator.connection
      console.log(connectionInfo.effectiveType, '-Internet-')
      console.log(connectionInfo.downlink, '-Internet-')
    } catch (error) {
      console.log(error)
    }
    await this.RunOnStart(uid)
  }

  async RunOnStart(uid) {
    apiGetHistoryRank().then((res) => {
      if (res.res.length) {
        this.state.historyRankList = res.res
        const [first] = res.res
        this.setState({ historyRank: first.list })
      }
    })
    apiUserGetHistoryRank().then((res) => {
      if (res.res.length) {
        this.state.userhistoryRankList = res.res
        const [first] = res.res
        this.setState({ userhistoryRank: first.list })
      }
    })

    apiUserGetHistoryRankStat().then((res) => {
      this.setState({ rank1Num: res.res.top1Num })
      this.setState({ rank2Num: res.res.top2Num })
      this.setState({ rank3Num: res.res.top3Num })
    })
    this.handleGetLastWeekChampion()
    this.handleGetWeekGift(0, 1)
    apiGetCountDown().then((res) => {
      this.setState({ time: res.res })
      if (res.res > 0) {
        this.countDown(res.res)
      }
    })
  }

  componentDidMount() {
    this.$logEvent('weeklyStar_main_screen')
  }

  hideRule = async (status) => {
    if (status) {
      this.$logEvent('weeklyStar_rule')
    }
    this.setState({
      ruleStatus: status,
    })
  }

  setShare = async (share, event) => {
    this.setState({ share: share })
    const ev = event || window.Event
    ev.stopPropagation()
  }

  async handleGetShareLink(event) {
    shareToLink('https://h5-activity.yayya.live/#/activity/weeklyStar')
    const ev = event || window.Event
    ev.stopPropagation()
  }
  async handleGetShareWhatsapp(event) {
    let link = 'https://h5-activity.yayya.live/#/activity/weeklyStar'
    shareToWhatsapp(this.state.lang.link + ' ' + link)
    const ev = event || window.Event
    ev.stopPropagation()
  }

  hideHistoryRankList = async (status) => {
    if (status) {
      this.$logEvent('weeklyStar_lastweek_rank')
    }
    this.setState({
      HistoryRankListStatus: status,
    })
  }

  hideuserHistoryRankList = async (status) => {
    this.setState({
      UserHistoryRankListStatus: status,
    })
  }

  async handleGetLastWeekChampion() {
    const res = await apiGetLastWeek(7)
    this.setState({ champion: res.res.avatarurl })
  }
  async handleGetWeekGift(number, num) {
    this.setState({ number: number })
    const res = await apiGetWeekGift(number)

    for (let v = 0; v < res.res.length; v++) {
      this.handleGetWeekGiftRank(res.res[v].giftid, number, v + 1)
    }

    this.apiGetRoomGiftRank()

    this.setState({ gift: res.res })
  }

  async handleGetWeekGiftRank(id, number, num) {
    const params = {
      daysago: number,
      giftid: id,
    }
    const res = await apiGetWeekGiftRank(params)
    if (num == 2) {
      this.setState({ giftrank2: res.res.list, giftNum: num })
      if (res.res != []) {
        this.setState({ myrank2: res.res.myrank })
      } else {
        this.setState({ myrank2: false })
      }
    } else if (num == 3) {
      this.setState({ giftrank3: res.res.list, giftNum: num })
      if (res.res != []) {
        this.setState({ myrank3: res.res.myrank })
      } else {
        this.setState({ myrank3: false })
      }
    } else if (num == 4) {
      this.setState({ giftrank4: res.res.list, giftNum: num })
      if (res.res != []) {
        this.setState({ myrank4: res.res.myrank })
      } else {
        this.setState({ myrank4: false })
      }
    } else {
      this.setState({ giftrank1: res.res.list, giftNum: 1 })
      if (res.res != []) {
        this.setState({ myrank1: res.res.myrank })
      } else {
        this.setState({ myrank1: false })
      }
    }
  }

  async apiGetRoomGiftRank() {
    const res = await apiGetRoomGiftRank(this.state.number)
    this.setState({ groupRank: res.res.list })
    if (res.res != []) {
      this.setState({ myGroupRank: res.res.myrank })
    } else {
      this.setState({ myGroupRank: false })
    }
  }

  async setTab(tab) {
    if (tab == 0) {
      this.$logEvent('weeklyStar_user_rank')
    }
    if (tab == 1) {
      this.$logEvent('weeklyStar_room_rank')
    }
    if (tab == 2) {
      this.$logEvent('weeklyStar_reward')
    }
    this.setState({ tab: tab })
  }

  countDown = (times) => {
    var timer = null
    let { language } = this.state
    timer = setInterval(
      function () {
        var day = 0,
          hour = 0,
          minute = 0,
          second = 0
        if (times > 0) {
          day = Math.floor(times / (60 * 60 * 24))
          hour = Math.floor(times / (60 * 60)) - day * 24
          minute = Math.floor(times / 60) - day * 24 * 60 - hour * 60
          second = Math.floor(times) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
        }
        if (day <= 9) day = day
        if (hour <= 9) hour = '0' + hour
        if (minute <= 9) minute = '0' + minute
        if (second <= 9) second = '0' + second
        let daystr = ''
        if (day > 0) {
          // daystr = day
          daystr = day + (language == 'tr' ? ' Gün ' : language == 'ar' ? ' يوم ' : ' days ')
        }
        //
        this.setState({ time: daystr + hour + ':' + minute + ':' + second })
        times--
      }.bind(this),
      1000,
    )
    if (times <= 0) {
      clearInterval(timer)
    }
  }

  renderLastWeek() {
    let { lang } = this.state
    return (
      <div className="week-last">
        <span className="week-last--title">{lang.lastText}</span>
        <img src="/img/app/week/title.png" alt="" />
        <div className="week-last--content">
          {this.state.historyRank &&
            this.state.historyRank.length > 0 &&
            this.state.historyRank.map((item, index) => {
              return (
                <div onClick={jumpToUser.bind(this, item.uid)} key={index}>
                  <img src={item.avatarurl} alt="" />
                  <img className="gift-image" src={item.giftImage} alt="" />
                  <p className="color">{item.nickname}</p>
                  <p>{score(item.val)}</p>
                </div>
              )
            })}
        </div>
        <div className="week-last--rank" onClick={this.hideHistoryRankList.bind(this, true)}>
          {this.state.lang.lastWeek || ''}
        </div>
      </div>
    )
  }

  setGiftNum(num) {
    this.setState({ giftNum: num })
  }

  renderWeekGift() {
    return (
      <div className="week-content--gift">
        {this.state.gift &&
          this.state.gift.length > 0 &&
          this.state.gift.map((item, k) => {
            return (
              <div onClick={this.setGiftNum.bind(this, k + 1)} key={item.giftid}>
                <img className={'trans3D' + k} src={item.image} alt="" />
                <img src="/img/app/week/despite.png" alt="" />
                <p>{item.gold}</p>
              </div>
            )
          })}

        {this.state.giftNum == 1 && <img className="img1" src="/img/app/week/icon.png" alt="" />}
        {this.state.giftNum == 2 && <img className="img2" src="/img/app/week/icon.png" alt="" />}
        {this.state.giftNum == 3 && <img className="img3" src="/img/app/week/icon.png" alt="" />}
        {this.state.giftNum == 4 && <img className="img4" src="/img/app/week/icon.png" alt="" />}
      </div>
    )
  }
  renderRank(index) {
    if (index === 0) return <img src="/img/app/week/one.png" alt="" />
    if (index === 1) return <img src="/img/app/week/two.png" />
    if (index === 2) return <img src="/img/app/week/three.png" />
    return <span>{index + 1}</span>
  }

  giftrank(giftrank, myrank) {
    return (
      <div className="week-content--list">
        {giftrank &&
          giftrank.map((item, index) => {
            return (
              <div className="list-item">
                <div className="item-rank">{this.renderRank(index)}</div>
                <img
                  onClick={jumpToUser.bind(this, item.uid)}
                  className="item-avatar"
                  src={cdn(item.avatarurl || item.logourl)}
                />
                <div onClick={jumpToUser.bind(this, item.uid)} className="item-info">
                  <p>{item.nickname || item.name}</p>
                  <p>ID:{item.duid || item.dgid}</p>
                </div>
                <div className="item-number">
                  <span>{score(item.val)}</span>
                  <img src="/img/app/week/gift.png" alt="" />
                </div>
              </div>
            )
          })}

        {myrank != false && myrank != undefined && (
          <div className="is-self list-item">
            <div className="item-rank">{myrank.rank}</div>
            <img
              onClick={jumpToUser.bind(this, myrank.uid)}
              className="item-avatar"
              src={cdn(myrank.avatarurl || myrank.logourl)}
            />
            <div onClick={jumpToUser.bind(this, myrank.uid)} className="item-info">
              <p>{myrank.nickname || myrank.name}</p>
              <p>ID:{myrank.duid || myrank.dgid}</p>
            </div>
            <div className="item-number">
              <span>{score(myrank.val)}</span>
              <img src="/img/app/week/gift.png" alt="" />
            </div>
          </div>
        )}
      </div>
    )
  }

  groupRank(giftrank, myGroupRank) {
    return (
      <div className="week-content--list">
        {giftrank &&
          giftrank.map((item, index) => {
            return (
              <div className="list-item">
                <div className="item-rank">{this.renderRank(index)}</div>
                <img
                  onClick={jumpToRoom.bind(this, item.gid)}
                  className="item-avatar2"
                  src={cdn(item.logourl)}
                />
                <div onClick={jumpToRoom.bind(this, item.gid)} className="item-info">
                  <p>{item.name}</p>
                  <p>ID:{item.dgid}</p>
                </div>
                <div className="item-number">
                  <span>{score(item.val)}</span>
                  <img src="/img/app/week/gift.png" alt="" />
                </div>
              </div>
            )
          })}

        {myGroupRank != false && myGroupRank != undefined && (
          <div className="is-self list-item">
            <div className="item-rank">{myGroupRank.rank}</div>
            <img
              onClick={jumpToRoom.bind(this, myGroupRank.gid)}
              className="item-avatar2"
              src={cdn(myGroupRank.logourl)}
            />
            <div onClick={jumpToRoom.bind(this, myGroupRank.gid)} className="item-info">
              <p>{myGroupRank.name}</p>
              <p>ID:{myGroupRank.dgid}</p>
            </div>
            <div className="item-number">
              <span>{score(myGroupRank.val)}</span>
              <img src="/img/app/week/gift.png" alt="" />
            </div>
          </div>
        )}
      </div>
    )
  }

  rewardList() {
    let { language } = this.state
    return (
      this.state.rewardList &&
      this.state.rewardList.map((r, i) => {
        return (
          <div className={`every_reward ${i > 2 && 'silver_back'}`}>
            <div className="rank">
              {language != 'tr' ? 'NO' : 'İlk'} {i + 1}
            </div>
            <div className={`content`}>
              {r &&
                r.list &&
                r.list.map((l, index) => {
                  return (
                    <div className="every_cont" key={index}>
                      <div>
                        <img src={l.pic}></img>
                      </div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            language == 'ar' ? l.days_ar : language == 'tr' ? l.days_tr : l.days,
                        }}
                      ></div>
                    </div>
                  )
                })}
            </div>
          </div>
        )
      })
    )
  }

  render() {
    let { language, lang } = this.state
    let historyRankListLen = this.state.historyRankList.length
    return (
      <div onClick={this.setShare.bind(this, false)} className="week-body">
        <div className="week-wrapper">
          <div className="bg week-bgc"></div>
          <div className="week-banner">
            <img
              className="week-banner--img_17 week-topd"
              src="/img/app/week/top/img_17.png"
              alt=""
            />
            <img className="week-banner--img_4900" src="/img/app/week/top/img_4900.png" alt="" />
            <img className="week-banner--champion" src={this.state.champion} alt="" />
            <img className="week-banner--star2" src="/img/app/week/top/star2.png" alt="" />
            <img className="week-banner--wing week-wing1" src="/img/app/week/top/wing.png" alt="" />
            <img
              className="week-banner--wing2 week-wing2"
              src="/img/app/week/top/wing2.png"
              alt=""
            />
            <img className="week-banner--bg week-addRotate" src="/img/app/week/top/bg.png" alt="" />
            <img
              className="week-banner--img_14 week-addRotate2"
              src="/img/app/week/top/img_14.png"
              alt=""
            />
            <img
              className="week-banner--img_15 week-smallBig"
              src="/img/app/week/top/img_15.png"
              alt=""
            />
            {/* <div className="bga animationFire"></div> */}
            {/* <div className="bga animationFire2"></div> */}
          </div>
          {this.renderLastWeek()}
          <div className="week-countdown">
            <p>
              {language == 'tr' ? 'Etkinlik Geri Sayımı' : 'Count Down'} {this.state.time}
            </p>
            <img src="/img/app/week/count.png" alt="" />
          </div>
          <div className="week-title">
            <div onClick={this.setTab.bind(this, 0)}>
              <img src="/img/app/week/room.png" alt="" />
              <span>{lang.user}</span>
            </div>
            {/* <div onClick={this.handleGetWeekGift.bind(this, 7)}>
            <img src="/img/app/week/this.png" alt="" />
            <span>Last Week</span>
          </div> */}
            {/* <div onClick={this.apiGetRoomGiftRank.bind(this)}> */}
            <div onClick={this.setTab.bind(this, 1)}>
              <img src="/img/app/week/week.png" alt="" />
              <span>{lang.room}</span>
            </div>
            <div onClick={this.setTab.bind(this, 2)}>
              <img src="/img/app/week/this.png" alt="" />
              <span>{lang.reward}</span>
            </div>
          </div>
          {this.state.tab == 0 && (
            <div className="week-content">
              <img className="week-content--head" src="/img/app/week/head.png" alt="" />
              {this.renderWeekGift()}
              <div className="week-content--line"></div>

              <div className={this.state.giftNum == 1 ? 'display' : 'hide'}>
                {this.giftrank(this.state.giftrank1, this.state.myrank1)}
              </div>
              <div className={this.state.giftNum == 2 ? 'display' : 'hide'}>
                {this.giftrank(this.state.giftrank2, this.state.myrank2)}
              </div>
              <div className={this.state.giftNum == 3 ? 'display' : 'hide'}>
                {this.giftrank(this.state.giftrank3, this.state.myrank3)}
              </div>
              <div className={this.state.giftNum == 4 ? 'display' : 'hide'}>
                {this.giftrank(this.state.giftrank4, this.state.myrank4)}
              </div>

              <img className="week-content--bottom" src="/img/app/week/bottom.png" alt="" />
            </div>
          )}

          {this.state.tab == 1 && (
            <div className="week-content">
              <img className="week-content--head" src="/img/app/week/head2.png" alt="" />
              {this.groupRank(this.state.groupRank, this.state.myGroupRank)}
              <img className="week-content--bottom" src="/img/app/week/bottom.png" alt="" />
            </div>
          )}

          {this.state.tab == 2 && (
            <div className="week-content">
              <img className="week-content--head" src="/img/app/week/head3.png" alt="" />
              {this.rewardList()}
              <img className="week-content--bottom" src="/img/app/week/bottom.png" alt="" />
            </div>
          )}

          <div className="week-tips">
            {language == 'tr'
              ? "Bu etkinliğin telif hakkı App'ye Aittir."
              : 'The copyright of this activity belongs to App'}
          </div>
          <div className="service" onClick={jumpToUser.bind(this, 977239)}>
            {lang.service}
          </div>

          <div className="rules" onClick={this.hideRule.bind(this, true)}>
            {this.state.lang.ruleText}
          </div>
          <div className="rules my" onClick={this.hideuserHistoryRankList.bind(this, true)}>
            {language == 'tr' ? 'Ben' : 'My'}
          </div>
          <div className="rr-temp">
            <div className="reward-rule-btn"></div>
            <div
              className="reward-rule-txt"
              onClick={() => {
                this.$logEvent('weeklyStar_reward_rule')
                this.setState({
                  rrShow: true,
                })
              }}
            >
              {this.state.lang.rewardtitle}
            </div>
          </div>
          <div
            className="reward-rule-content"
            style={{ display: this.state.rrShow ? 'block' : 'none' }}
            onClick={() => {
              this.setState({
                rrShow: false,
              })
            }}
          >
            <div
              className={`txt ${language == 'ar' && 'arlang'}`}
              dangerouslySetInnerHTML={{ __html: this.state.lang.rewardRule }}
            ></div>
          </div>

          {/* <div onClick={this.setShare.bind(this, true)}  className='share-icon'></div> */}

          {this.state.ruleStatus && (
            <div className="loading" onClick={this.hideRule.bind(this, false)}></div>
          )}
          {this.state.ruleStatus && (
            <div
              className={`popRule animationBeBigCenter`}
              onClick={this.hideRule.bind(this, false)}
            >
              <div
                className={`content ${language == 'ar' && 'arlang'}`}
                dangerouslySetInnerHTML={{ __html: lang.rule }}
              ></div>
            </div>
          )}
          {/* {showPop && <Rule language={language} lang={this.state.lang} ref="rule" />} */}

          {this.state.HistoryRankListStatus && (
            <div
              className="historyRankListLoading"
              onClick={this.hideHistoryRankList.bind(this, false)}
            ></div>
          )}
          {this.state.HistoryRankListStatus && (
            <div
              className={`historyRankList animationBeBigCenter ${historyRankListLen == 1 && 'historyRankList1'}`}
              onClick={this.hideHistoryRankList.bind(this, false)}
            >
              {this.state.historyRankList &&
                this.state.historyRankList.map((item, index) => {
                  return (
                    <div className="week-last" key={index}>
                      <span className="week-last--title">{item.statdate}</span>
                      <img src="/img/app/week/title.png" alt="" />
                      <div className="week-last--content">
                        {item &&
                          item.list &&
                          item.list.map((value) => {
                            return (
                              <div>
                                <img src={value.avatarurl} alt="" />
                                <img className="gift-image" src={value.giftImage} alt="" />
                                <p className="color">{value.nickname}</p>
                                <p>{score(value.val)}</p>
                              </div>
                            )
                          })}
                      </div>
                    </div>
                  )
                })}
            </div>
          )}

          {this.state.UserHistoryRankListStatus && (
            <div
              className="historyRankListLoading"
              onClick={this.hideuserHistoryRankList.bind(this, false)}
            ></div>
          )}
          {this.state.UserHistoryRankListStatus && (
            <div
              className={`historyRankList animationBeBigCenter ${historyRankListLen == 1 && 'historyRankList1'}`}
              onClick={this.hideuserHistoryRankList.bind(this, false)}
            >
              <div className="rank-stat-box">
                <div>
                  <img className="index-rank" src="/img/activity/fruitgame/index-1.png" alt="" />
                  <span>x{this.state.rank1Num}</span>
                </div>
                <div>
                  <img className="index-rank" src="/img/activity/fruitgame/index-2.png" alt="" />
                  <span>x{this.state.rank2Num}</span>
                </div>
                <div>
                  <img className="index-rank" src="/img/activity/fruitgame/index-3.png" alt="" />
                  <span>x{this.state.rank3Num}</span>
                </div>
              </div>

              {this.state.userhistoryRankList &&
                this.state.userhistoryRankList.map((item, index) => {
                  return (
                    <div className="week-last">
                      <span className="week-last--title">{item.statdate}</span>
                      <img src="/img/app/week/title.png" alt="" />
                      <div className="week-last--content">
                        {item &&
                          item.list &&
                          item.list.map((value) => {
                            return (
                              <div>
                                {value.giftImage != '' && <img src={value.giftImage} alt="" />}
                                {value.giftImage == '' && <p className="color">{lang.totalgift}</p>}
                                {/* <img className="gift-image" src={value.giftImage} alt="" /> */}
                                <p className="color">No.{value.rank}</p>
                                {/* <p>{score(value.val)}</p> */}
                              </div>
                            )
                          })}
                      </div>
                    </div>
                  )
                })}
            </div>
          )}
        </div>

        {this.state.share && (
          <div className="gold-share">
            <div className="gold-share--title">{lang.share}</div>
            <div className="gold-share--content">
              <img onClick={this.handleGetShareLink.bind(this)} src="/img/app/gold/link.png" />
              <img
                onClick={this.handleGetShareWhatsapp.bind(this)}
                src="/img/app/gold/whatsapp.png"
                alt=""
              />
            </div>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/weeklyStar/index.js